// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"ed6ed1b3","513":"81c416ac"}[chunkId] + ".chunk.js";
};